import { ProfileViewerContainer } from 'containers/profile-views/components/viewers-details/ProfileContainer'
import { useEffect, useMemo, useRef, useState } from 'react'

interface ProfileCardLikeProps {
  id: string
  onIntersect?: () => void
}

export const ProfileCardLike = ({ id, onIntersect }: ProfileCardLikeProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isIntersecting, setIntersecting] = useState(false)

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) =>
        setIntersecting(entry.isIntersecting)
      ),
    []
  )

  useEffect(() => {
    observer.observe(containerRef.current)
    return () => observer.disconnect()
  }, [observer])

  useEffect(() => {
    if (isIntersecting && onIntersect) {
      onIntersect()
    }
  }, [isIntersecting, onIntersect])

  return (
    <div
      className="border-solid border-secondary border-1 rounded-14"
      ref={containerRef}
    >
      <div>
        <ProfileViewerContainer id={id} />
      </div>
    </div>
  )
}
